import React, { useEffect, useState } from "react";
import {
  FormControl,
  Typography,
  Autocomplete,
  TextField,
  Select,
  MenuItem,
  Box,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import {
  fetchFosaFacilityUserPositions,
  GetConsultantHfInsuree,
  GetInsuresByHealthFacility,
  fetchMedicalStaffInsureeByFilter,
} from "../action";
import { MEDICAL_STAFF_DESIGNATION } from "../utils/constant";

const Content = styled(Typography)`
  margin-bottom: 0.5rem;
`;

const MedicalOfficerPicker = ({
  input,
  value,
  reset,
  userHealthFacilityFullPath,
  withLabel = true,
  label = null,
  required = false,
  allRegions,
  region,
  meta,
  error,
  hf_Uuid,
  principalDoctor,
  ...props
}) => {
  const [selectedValue, setSelectedValue] = useState(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const SignInSuccess = useSelector((state) => state);

  const healthData =
    SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0];

  const fosaHealthFacilityPositionItems =
    SignInSuccess?.fosaReducer?.fosaHealthFacilityPositionItems;

  useEffect(() => {
    if (!fosaHealthFacilityPositionItems) {
      dispatch(fetchFosaFacilityUserPositions());
    }
  }, [dispatch, fosaHealthFacilityPositionItems]);

  const buildQueryParams = (state) => {
    let params = Object.keys(state.filters)
      .filter((f) => !!state.filters[f]["filter"])
      .map((f) => state.filters[f]["filter"]);
    if (!state.beforeCursor && !state.afterCursor) {
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.afterCursor) {
      params.push(`after: "${state.afterCursor}"`);
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.beforeCursor) {
      params.push(`before: "${state.beforeCursor}"`);
      params.push(`last: ${state.pageSize}`);
    }
    if (!!state.orderBy) {
      params.push(`orderBy: ["${state.orderBy}"]`);
    }
    if (!!state.healthFacility_Uuid) {
      params.push(`healthFacility_Uuid: "${state?.healthFacility_Uuid}"`);
    }

    if (!!state.policyHolderId) {
      params.push(`policyHolder_Code: "${state.policyHolderId}"`);
    }
    return params;
  };

  useEffect(() => {
    if (healthData) {
      let jsonObject;
      if (healthData?.jsonExt) {
        jsonObject = JSON.parse(healthData?.jsonExt);
      }

      const camuCode = jsonObject?.camuCode;

      const params = buildQueryParams({
        filters: false,
        orderBy: "date_created",
        pageSize: 30,
        beforeCursor: null,
        afterCursor: null,
        policyHolderId: camuCode,
      });

      dispatch(fetchMedicalStaffInsureeByFilter(params));
    }
  }, [dispatch, healthData]);

  useEffect(() => {
    if (hf_Uuid) {
      dispatch(GetInsuresByHealthFacility(hf_Uuid));

      let params = buildQueryParams({
        filters: false,
        orderBy: "[insuree]",
        pageSize: 30,
        beforeCursor: null,
        afterCursor: null,
        healthFacility_Uuid: hf_Uuid,
      });
      dispatch(GetConsultantHfInsuree(params));
    }
  }, [hf_Uuid]);
  // useEffect(() => {
  //     if (selectedValue) {
  //         dispatch(fetchInsureeByUuid(selectedValue))
  //     }
  // },[selectedValue])
  const HfInsuree = useSelector((state) => state?.fosaReducer?.HfInsuree);
  const consultants = useSelector(
    (state) => state?.fosaReducer?.getConsultantData
  );

  const handleChange = (event) => {
    const selectedRegion = event.target.value;
    setSelectedValue(selectedRegion);
  };

  return (
    <>
      <Content>
        <Typography required={required} color="#666666">
          {label}
          {required ? "*" : ""}
        </Typography>
      </Content>
      <FormControl fullWidth>
        <Select
          value={value}
          onChange={handleChange}
          displayEmpty
          required={required}
          size="small"
          error={meta && meta.touched && meta.error && error}
          {...input}
          {...props}
        >
          <MenuItem disabled value="">
            <em>{t("Select")}</em>
          </MenuItem>
          <Typography style={{ paddingLeft: "1rem", fontWeight: "bold" }}>
            Permanents
          </Typography>

          {HfInsuree &&
            HfInsuree.filter((item) => {
              const jsonExt =
                item.policyholderinsureeSet?.edges?.[0]?.node?.jsonExt;
              if (jsonExt) {
                try {
                  const parsedData = JSON.parse(jsonExt);

                  if (
                    parsedData?.position_id &&
                    fosaHealthFacilityPositionItems &&
                    fosaHealthFacilityPositionItems.find(
                      (item) => item.id === parsedData?.position_id
                    )?.isHealthProfessional
                  ) {
                    return true;
                  }

                  return false;
                } catch (error) {
                  console.error("Error parsing JSON:", error);
                }
              }
              return false;
            }).map((region) => (
              <MenuItem key={region.id} value={region?.uuid}>
                {`${region.chfId} ${region.lastName} ${region.otherNames}`}
              </MenuItem>
            ))}
          <Typography style={{ paddingLeft: "1rem", fontWeight: "bold" }}>
            Prestataires
          </Typography>
          {consultants &&
            consultants.length > 0 &&
            consultants
              .filter((consultant) => {
                return (
                  consultant?.position?.isHealthProfessional &&
                  consultant?.insuree?.uuid !== principalDoctor
                );
              })
              .map((consultant) => (
                <MenuItem
                  key={consultant?.insuree?.id}
                  value={consultant?.insuree?.uuid}
                >
                  {`${consultant?.insuree?.camuNumber} ${consultant?.insuree?.lastName} ${consultant?.insuree?.otherNames}`}
                </MenuItem>
              ))}
        </Select>
        {meta && meta.touched && meta.error ? (
          <Typography color="red" fontSize={".8rem"} align={"center"}>
            {error}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
      {/* <FormControl fullWidth>
                <Autocomplete
                    options={HfInsuree || []}
                    value={selectedValue}
                    getOptionLabel={(option) => `${option.chfId} ${option.lastName} ${option.otherNames}`}
                    onChange={handleChange}
                    renderInput={(params) => <TextField {...params} label="" />}
                    {...props}
                />
                {meta && meta.touched && meta.error ? (
                    <Typography color="red" fontSize={".8rem"} align={"center"}>
                        {error}
                    </Typography>
                ) : null}
            </FormControl> */}
    </>
  );
};

export default MedicalOfficerPicker;
